export const aciTv = {
    iconName: 'tv',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 25 24' },
        path: [
            {
                attr: {
                    d: 'M20.967 4.62H4.828a.787.787 0 00-.787.787V15.64c0 .435.352.787.787.787h16.14a.787.787 0 00.786-.787V5.407a.787.787 0 00-.787-.787zM6.402 16.428l-1.771 2.953M19.393 16.428l1.77 2.953',
                    stroke: 'currentColor',
                    'stroke-width': '1.2',
                    'stroke-linecap': 'round',
                    'stroke-linejoin': 'round',
                },
            },
            {
                attr: {
                    d: 'M20.967 4.62H4.828a.787.787 0 00-.787.787V15.64c0 .435.352.787.787.787h16.14a.787.787 0 00.786-.787V5.407a.787.787 0 00-.787-.787zM6.402 16.428l-1.771 2.953M19.393 16.428l1.77 2.953',
                    stroke: 'currentColor',
                    'stroke-width': '1.2',
                    'stroke-linecap': 'round',
                    'stroke-linejoin': 'round',
                },
            },
        ],
    },
};
